import superagent from 'superagent'
import { encrypt } from '@/utils/des'
import { host, tokenPrefix } from './host'

const updateAdvert = (data) => {
    return new Promise((resolve, reject) => {
        superagent.put(`${host}/v1/advertisement/create`)
            .set('token', encrypt(`${tokenPrefix}.advertisement`))
            .send({
                advertisement_id: "default_ad",
                data: JSON.stringify(data)
            })
            .then((res) => {
                if (res.body.err === 0) {
                    resolve(res.body.data)
                }
            }, (err) => {
                reject(err)
            })
    })
    
}

const getAdvert = () => {
    return new Promise((resolve, reject) => {
        superagent.get(`${host}/v1/advertisement/detail`)
           .set('token', encrypt(`${tokenPrefix}.advertisement`))
           .send({})
           .then((res) => {
                if (res.body.err === 0) {
                    resolve(res.body.data)
                }
            })
        })
    }

export {
    updateAdvert,
    getAdvert,
}